import { PropsWithChildren, createContext, useState } from 'react';

export const SidebarNavItemCollapseContext = createContext<{
  currentMenuActive: string | null;
  setCurrentMenuActive: (id: string | null) => void;
}>({
  currentMenuActive: null,
  setCurrentMenuActive: () => {}
});

export const SidebarContext = createContext<{
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
}>({
  sidebarOpen: false,
  setSidebarOpen: () => {}
});

export const SidebarNavItemCollapseProvider = ({ children }: PropsWithChildren) => {
  const [currentMenuActive, setCurrentMenuActive] = useState<string | null>(null);

  return (
    <SidebarNavItemCollapseContext.Provider value={{ currentMenuActive, setCurrentMenuActive }}>
      {children}
    </SidebarNavItemCollapseContext.Provider>
  );
};

export const SidebarProvider = ({ children }: PropsWithChildren) => {
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(true);

  return <SidebarContext.Provider value={{ sidebarOpen, setSidebarOpen }}>{children}</SidebarContext.Provider>;
};
